import { createBrowserRouter } from 'react-router-dom'
import { RedirectIfAuthenticated, RequireAuth } from '@/features/auth/RequireAuth'
import { lazyPage } from './lazyPage'
import { RouteErrorBoundary } from './RouteErrorBoundary'
import { workspaceRoutes } from './workspaceRoutes'

export const router = createBrowserRouter([
  {
    element: <RedirectIfAuthenticated />,
    errorElement: <RouteErrorBoundary />,
    children: [
      { path: '/login', element: lazyPage(() => import('@/pages/auth/LoginPage')) },
      { path: '/signup', element: lazyPage(() => import('@/pages/auth/SignupPage')) },
      { path: '/password-reset', element: lazyPage(() => import('@/pages/auth/PasswordResetPage')) },
    ],
  },
  // Public pages that work whether or not the visitor is signed in (same as the legacy portal).
  { path: '/verify-email', element: lazyPage(() => import('@/pages/auth/VerifyEmailPage')), errorElement: <RouteErrorBoundary /> },
  { path: '/privacy-policy', element: lazyPage(() => import('@/pages/auth/PrivacyPolicyPage')), errorElement: <RouteErrorBoundary /> },
  { path: '/auth/handoff', element: lazyPage(() => import('@/pages/auth/HandoffPage')), errorElement: <RouteErrorBoundary /> },
  // The signed-in workspace: app shell plus every page (see workspaceRoutes.tsx).
  {
    element: <RequireAuth />,
    errorElement: <RouteErrorBoundary />,
    children: workspaceRoutes,
  },
])
